// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/hooks/useOrganizationRoomPath.ts"
);
import.meta.hot.lastModified = "1747581128671.922";
}
// REMIX HMR END

import { nanoid } from 'nanoid'

/**
 * Generates a room path that optionally includes an organization prefix under the /m/ path
 *
 * @param orgPrefix Optional organization prefix
 * @returns A path string for the room
 */
export function generateRoomPath(orgPrefix?: string | null): string {
	const roomId = nanoid(8)
	return orgPrefix ? `/m/${orgPrefix}/${roomId}` : `/m/${roomId}`
}

/**
 * Parses a room path to extract organization and room name
 *
 * @param roomPath The room path (e.g. "m/quora/meeting-room" or "m/xyz123")
 * @returns Object with organization and roomName
 */
export function parseRoomPath(roomPath: string): {
	organization?: string
	roomName: string
} {
	// Remove leading /m/ if present
	const normalizedPath = roomPath.replace(/^\/m\//, '')

	if (normalizedPath.includes('/')) {
		const [organization, roomName] = normalizedPath.split('/')
		return { organization, roomName }
	}

	return { roomName: normalizedPath }
}
